import { Card } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { useBlockHeight } from "@/hooks/useBlockHeight";
import { Skeleton } from "@/components/ui/skeleton";

const HalvingCountdown = () => {
  const { data: blockData, isLoading } = useBlockHeight();
  
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    if (!blockData) return;

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const halvingDate = new Date(blockData.estimatedDate).getTime();
      const distance = halvingDate - now;

      if (distance < 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [blockData]);

  if (isLoading) {
    return (
      <Card className="p-6 bg-gradient-to-br from-card to-primary/10 border-primary/30 min-h-[180px]">
        <h3 className="text-lg font-semibold mb-4 text-primary">Next Halving Countdown</h3>
        <div className="grid grid-cols-4 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="text-center">
              <Skeleton className="h-10 w-16 mx-auto mb-2" />
              <Skeleton className="h-4 w-12 mx-auto" />
            </div>
          ))}
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6 bg-gradient-to-br from-card to-primary/10 border-primary/30 min-h-[180px]">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-lg font-semibold text-primary">Next Halving Countdown</h3>
        {blockData && (
          <div className="text-right">
            <div className="text-xs text-muted-foreground">Block {blockData.currentBlock.toLocaleString()}</div>
            <div className="text-xs text-muted-foreground">{blockData.blocksRemaining.toLocaleString()} blocks left</div>
          </div>
        )}
      </div>
      <div className="grid grid-cols-4 gap-4">
        <div className="text-center">
          <div className="text-3xl font-bold text-primary">{timeLeft.days}</div>
          <div className="text-xs text-muted-foreground">Days</div>
        </div>
        <div className="text-center">
          <div className="text-3xl font-bold text-primary">{timeLeft.hours}</div>
          <div className="text-xs text-muted-foreground">Hours</div>
        </div>
        <div className="text-center">
          <div className="text-3xl font-bold text-primary">{timeLeft.minutes}</div>
          <div className="text-xs text-muted-foreground">Minutes</div>
        </div>
        <div className="text-center">
          <div className="text-3xl font-bold text-primary">{timeLeft.seconds}</div>
          <div className="text-xs text-muted-foreground">Seconds</div>
        </div>
      </div>
      {blockData && (
        <div className="mt-4 pt-4 border-t border-primary/20">
          <div className="text-xs text-center text-muted-foreground">
            Target: Block 1,050,000 • Est: {new Date(blockData.estimatedDate).toLocaleDateString('en-US', { 
              month: 'short', 
              day: 'numeric', 
              year: 'numeric' 
            })}
          </div>
        </div>
      )}
    </Card>
  );
};

export default HalvingCountdown;
